export const FIRESTORE_BATCH_LIMIT = 500;
export const MAX_WRITES_PER_CLASS_BATCH = 450;

const countArray = (value) => (Array.isArray(value) ? value.length : 0);

const getUniqueClassIds = (...sources) => [
  ...new Set(
    sources
      .flatMap((source) => Object.keys(source || {}))
      .map((classId) => String(classId || ""))
      .filter(Boolean)
  ),
];

export function estimateCalendarCopyWritesByClass({
  writesByClass = {},
  updatesByClass = {},
  orderMergeSegmentsByClass = {},
} = {}) {
  return Object.fromEntries(
    getUniqueClassIds(writesByClass, updatesByClass, orderMergeSegmentsByClass).map((classId) => {
      const writesCount = countArray(writesByClass[classId]);
      const updatesCount = countArray(updatesByClass[classId]);
      const orderSegmentsCount = countArray(orderMergeSegmentsByClass[classId]);
      const needsOrderWrite = writesCount > 0 || updatesCount > 0 || orderSegmentsCount > 0;
      return [classId, writesCount + updatesCount + (needsOrderWrite ? 1 : 0)];
    })
  );
}

export function estimateCalendarCopyUndoWritesByClass(copyClasses = []) {
  return Object.fromEntries(
    (copyClasses || [])
      .filter((classSnapshot) => classSnapshot?.classId)
      .map((classSnapshot) => {
        const createdCount = countArray(classSnapshot.createdIds);
        const updatedCount = countArray(classSnapshot.updatedActiveDates);
        const needsOrderWrite =
          createdCount > 0 ||
          updatedCount > 0 ||
          countArray(classSnapshot.previousOrder) > 0;
        return [
          String(classSnapshot.classId),
          createdCount + updatedCount + (needsOrderWrite ? 1 : 0),
        ];
      })
  );
}

export function estimateCalendarDeleteUndoWritesByClass(deleteClasses = {}) {
  return Object.fromEntries(
    Object.entries(deleteClasses || {}).map(([classId, classSnapshot]) => {
      const targetBoxCount = Object.keys(classSnapshot?.boxes || {}).length;
      return [String(classId), targetBoxCount + 1];
    })
  );
}

export function getBatchLimitBreach(
  estimatesByClassId = {},
  limit = MAX_WRITES_PER_CLASS_BATCH
) {
  const breachedClassIds = Object.entries(estimatesByClassId || {})
    .filter(([, writes]) => Number(writes || 0) > limit)
    .map(([classId]) => classId);
  const maxWrites = Object.values(estimatesByClassId || {}).reduce(
    (max, writes) => Math.max(max, Number(writes || 0)),
    0
  );

  return {
    ok: breachedClassIds.length === 0,
    limit,
    maxWrites,
    breachedClassIds,
  };
}
